import { routerComponentMap } from '../router/router-component'
// 加载路由菜单,从localStorage拿到路由,在创建路由时使用
export const dynamicRouterAdd = () => {
  let data = sessionStorage.getItem('dynamicRouter')
  if (!data) {
    return []
  }
  return filterAsyncRouter(JSON.parse(data))
}

// @函数: 遍历后台传来的路由字符串，转换为组件对象
export const filterAsyncRouter = (asyncRouterMap) => {
  let accessedRouters = []
  if (asyncRouterMap) {
    asyncRouterMap.filter(route => {
      if (route.show === 1) {
        let accessedRouter = {}
        accessedRouter.path = route.parent_id === 0 ? `/${route.key}` : route.key
        accessedRouter.name = route.key
        accessedRouter.meta = {
          icon: route.icon,
          title: route.title,
          notCache: false,
          hideInMenu: false
        }
        accessedRouter.component = routerComponentMap[route.key]
        if (route.children && route.children.length) {
          accessedRouter.children = filterAsyncRouter(route.children)
        }
        accessedRouters.push(accessedRouter)
      }
    })
  }
  return accessedRouters
}
